import { createSlice } from "@reduxjs/toolkit";

const userSlice = createSlice({
  name: "user",
  initialState: {
    user: {},
    token: "",
    sToken: "",
    sUrl: "",
    routePermission: [],
    marketWatchScripts: "",
  },
  reducers: {
    updateUser(state, action) {
      state.user = action.payload;
    },
    setToken(state, action) {
      state.token = action.payload;
    },
    setSToken(state, action) {
      state.sToken = action.payload;
    },
    clearUser(state) {
      state.user = {};
      state.token = "";
    },
    setSurl(state, action) {
      // state.sUrl = action.payload;
      state.sUrl = action.payload;
    },
    setMarketWatchScripts(state, action) {
      state.marketWatchScripts = action.payload;
    },
  },
});

export const userAction = userSlice.actions;
export default userSlice;
